module.exports = __webpack_public_path__ + "1cce3c20db0e13a43c5c9d3aac3a83b3.svg";